import React from "react";
const Loading = () => {
  return <div className="spinner-border container-fluid"></div>;
};
export default Loading;
